import React, { FC } from 'react'
import { useAtom } from 'jotai'
import { TabbedMenu, TabItem } from '../../ui/TabbedMenu'
import { L } from '../../providers/Lokalise'
import { profileAtom } from '../../../api/profile/profile'
import { canAccessLoenindplaceringer } from '../../../store/auth'

export interface ILinkItem {
    to: string
    label: string
}

const links: ILinkItem[] = [
    {
        to: '/mine-medlemmer',
        label: 'HEADER_FANEBLAD_EGNEMEDLEMMER-TITEL',
    },
    {
        to: '/alle-foas-medlemmer',
        label: 'HEADER_FANEBLAD_ALLEMEDLEMMER-TITEL',
    },
    {
        to: '/mine-arbejdsteder',
        label: 'HEADER_FANEBLAD_MINEARBEJDSSTEDER-TITEL',
    },
    {
        to: '/mine-noter',
        label: 'HEADER_FANEBLAD_MINENOTER-TITEL',
    },
    {
        to: '/mine-opdateringer',
        label: 'HEADER_FANEBLAD_MINEOPDATERINGER-TITEL',
    },
]

const linksForLoenindplaceringer: ILinkItem[] = [
    ...links,
    {
        to: '/mine-lonindplaceringer',
        label: 'HEADER_FANEBLAD_LONINDPLACERINGER-TITEL',
    },
]

const linksForSupporter: ILinkItem[] = [
    {
        to: '/mine-medlemmer',
        label: 'HEADER_FANEBLAD_EGNEMEDLEMMER-TITEL',
    },
    {
        to: '/alle-foas-medlemmer',
        label: 'HEADER_FANEBLAD_ALLEMEDLEMMER-TITEL',
    },
    {
        to: '/mine-arbejdsteder',
        label: 'HEADER_FANEBLAD_MINEARBEJDSSTEDER-TITEL',
    },
    {
        to: '/mine-noter',
        label: 'HEADER_FANEBLAD_MINENOTER-TITEL',
    },
    {
        to: '/mine-opdateringer',
        label: 'HEADER_FANEBLAD_MINEOPDATERINGER-TITEL',
    },
]

const Menu: FC = () => {
    const [authProfile] = useAtom(profileAtom)
    const [_canAccessLoenindplaceringer] = useAtom(canAccessLoenindplaceringer)
    const linksToUse = _canAccessLoenindplaceringer
        ? linksForLoenindplaceringer
        : linksForSupporter

    return (
        <TabbedMenu>
            {linksToUse.map((link: ILinkItem) => {
                return (
                    <TabItem
                        key={link.label}
                        to={link.to}
                        label={L(link.label)}
                    />
                )
            })}
        </TabbedMenu>
    )
}

export { Menu }
